export const type = 'showEditProduct';

const showEditProduct = (product) => ({
    type,
    payload: product,
});

export default showEditProduct;